module.exports = __webpack_public_path__ + "static/media/768px.2f77bb19.png";